import DatePicker from 'react-datepicker'
import dayjs from 'dayjs'
import React, { memo } from 'react'

const SearchableSelect = ({ item, isReadOnly, changeRegistrationProperty }) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [searchText, setSearchText] = React.useState('')
  const [hasTyped, setHasTyped] = React.useState(false)
  const options = [
    ...(item.defaultValue?.value != null &&
    !item.options?.some(
      (option) => String(option.value) === String(item.defaultValue.value),
    )
      ? [item.defaultValue]
      : []),
    ...(item.options ?? []),
  ]
  const selectedOption = options.find(
    (option) => String(option.value) === String(item.value ?? ''),
  )
  const visibleOptions = options.filter((option) =>
    String(option.label ?? '')
      .toLocaleLowerCase()
      .includes((hasTyped ? searchText : '').trim().toLocaleLowerCase()),
  )

  const handleSelect = (option) => {
    setIsOpen(false)
    setSearchText('')
    setHasTyped(false)
    if (item.onChange) {
      item.onChange(option, option.value)
    } else {
      changeRegistrationProperty(item.fieldName, option.value)
    }
  }

  return (
    <div
      className="registration-searchable-select"
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          setIsOpen(false)
          setSearchText('')
          setHasTyped(false)
        }
      }}
    >
      <input
        id={item.fieldName}
        name={item.fieldName}
        type="text"
        className="form-control input-dot"
        value={isOpen ? searchText : (selectedOption?.label ?? '')}
        placeholder={item.defaultValue?.label ?? 'Chọn'}
        autoComplete="off"
        disabled={isReadOnly}
        aria-label={item.label}
        aria-autocomplete="list"
        aria-expanded={isOpen}
        onFocus={(event) => {
          setSearchText(selectedOption?.label ?? '')
          setHasTyped(false)
          setIsOpen(true)
          event.currentTarget.select()
        }}
        onChange={(event) => {
          setSearchText(event.target.value)
          setHasTyped(true)
          setIsOpen(true)
        }}
        onKeyDown={(event) => {
          if (event.key === 'Escape') {
            setIsOpen(false)
            setSearchText('')
            setHasTyped(false)
          } else if (event.key === 'Enter' && visibleOptions[0]) {
            event.preventDefault()
            handleSelect(visibleOptions[0])
          }
        }}
      />
      {isOpen && (
        <div className="registration-searchable-select-options" role="listbox">
          {visibleOptions.length ? (
            visibleOptions.map((option) => (
              <button
                key={option.value}
                type="button"
                className={`registration-searchable-select-option${
                  String(option.value) === String(item.value ?? '')
                    ? ' selected'
                    : ''
                }`}
                role="option"
                aria-selected={
                  String(option.value) === String(item.value ?? '')
                }
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => handleSelect(option)}
              >
                {option.label}
              </button>
            ))
          ) : (
            <div className="registration-searchable-select-empty">
              Không tìm thấy kết quả
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export const InputField = memo(
  ({ item, screenAction, changeRegistrationProperty, id }) => {
    const isReadOnly = screenAction === 'xem'
    switch (item.type) {
      case 'select': {
        return (
          <SearchableSelect
            item={item}
            isReadOnly={isReadOnly}
            changeRegistrationProperty={changeRegistrationProperty}
          />
        )
      }

      case 'date':
        return (
          <DatePicker
            id={id}
            dateFormat="dd/MM/yyyy"
            customInput={
              <input
                type="text"
                className="form-control input-dot input-date"
              />
            }
            onChangeRaw={(e) => {
              const newDate = dayjs(
                e?.target?.value?.trim(),
                'DD/MM/YYYY',
                true,
              )
              if (newDate.isValid()) {
                changeRegistrationProperty(
                  item.fieldName,
                  dayjs(newDate).format('YYYY-MM-DD HH:mm:ss'),
                )
              }
            }}
            // showIcon={true}
            todayButton={<button>Hôm nay</button>}
            readOnly={isReadOnly}
            selected={item.value ? new Date(item.value) : ''}
            onChange={(value) => {
              changeRegistrationProperty(item.fieldName, value)
            }}
          />
        )
      case 'radio':
        return (
          <div
            className="radio-group"
            style={{ display: 'flex', alignItems: 'center', gap: '15px' }}
          >
            {item.options?.map((opt, i) => (
              <span key={i} className="radio-label">
                <input
                  type="radio"
                  name={item.fieldName}
                  value={opt.value}
                  id={i}
                  checked={item.value == opt.value}
                  disabled={isReadOnly}
                  onChange={(e) =>
                    changeRegistrationProperty(item.fieldName, e.target.value)
                  }
                />
                <label
                  for={i}
                  style={{
                    cursor: 'pointer',
                    marginLeft: '5px',
                    marginBottom: 0,
                  }}
                >
                  {opt.label}
                </label>
              </span>
            ))}
          </div>
        )

      default:
        return (
          <input
            type={item.type || 'text'}
            className="form-control input-dot"
            value={item.value ?? ''}
            readOnly={isReadOnly}
            onBlur={(e) =>
              changeRegistrationProperty(item.fieldName, e.target.value?.trim())
            }
            onChange={(e) =>
              changeRegistrationProperty(item.fieldName, e.target.value)
            }
          />
        )
    }
  },
)
